module.exports = __webpack_public_path__ + "img/PK_Asset_Info_Web_Text1.2e150097.png";